// mt-home.js für Startseite, Ratgeber und Blog (Kail 08.10.2026, nach der Prüfung vom 09.10. ergänzt).
// 1. Reiter-Reihe: die feste Reihenfolge aus mt-home.css schiebt mobil den aktiven Reiter oft rechts aus dem Bild, also hinscrollen.
// 2. Startseite mobil: „Nur das Beste für deine Haut“ steht per CSS untereinander, der Slider des Themes versteckt aber zwei der
//    drei sichtbaren Karten vor Screenreadern und macht die Liste per Tab fokussierbar. Beides wird zurückgenommen.
// 3. Artikel: das Inhaltsverzeichnis rechts blendet sich ein, sobald man beim Text angekommen ist, und markiert beim Lesen
//    den Abschnitt, in dem man gerade ist.
(() => {
  const reihe = document.querySelector('#main .blogs-navigation-wrapper');
  const aktiv = reihe && reihe.querySelector('a.text--underline');
  if (aktiv && reihe.scrollWidth > reihe.clientWidth) {
    const a = aktiv.getBoundingClientRect(), r = reihe.getBoundingClientRect();
    reihe.scrollLeft += a.left + a.width / 2 - (r.left + r.width / 2);
  }
})();

(() => {
  const liste = document.querySelector('#main .text-with-icon-list');
  if (!liste) return;
  const frei = () => {
    if (innerWidth >= 990) return;
    liste.removeAttribute('tabindex');
    liste.querySelectorAll('[aria-hidden]').forEach(e => e.removeAttribute('aria-hidden'));
  };
  new MutationObserver(frei).observe(liste, { subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex'] });
  frei();
})();

(() => {
  const toc = document.querySelector('.rg-article .bb-toc');
  const liste = toc && toc.querySelector('.bb-toc__list');
  if (!liste) return;
  const text = toc.closest('.bb-container');
  const paare = [...liste.querySelectorAll('.bb-toc__link')]
    .map(a => [a, document.getElementById(decodeURIComponent(a.hash.slice(1)))])
    .filter(([, h]) => h);
  if (!paare.length) return;
  // index.js des Themes fängt Ankerklicks ab und scrollt auf offsetTop minus data-offset, sonst landet der Titel unter der Kopfzeile
  paare.forEach(([a]) => { a.dataset.offset = 110; });
  toc.classList.add('mt-js');
  let jetzt = -1;
  const setze = () => {
    toc.classList.toggle('is-da', text.getBoundingClientRect().top < 150);
    // aktiv ist der letzte Abschnitt, dessen Titel 200 px vom oberen Rand passiert hat (ein Klick setzt ihn auf 110 px, so
    // gilt auch ein kurzer Abschnitt davor nicht mehr). Am Ende des Artikels gilt der letzte Titel, der im Bild ist
    const grenze = text.getBoundingClientRect().bottom <= innerHeight + 1 ? innerHeight : 200;
    let i = 0;
    paare.forEach(([, h], n) => { if (h.getBoundingClientRect().top < grenze) i = n; });
    if (i === jetzt) return;
    jetzt = i;
    paare.forEach(([a], n) => n === i ? a.setAttribute('aria-current', 'location') : a.removeAttribute('aria-current'));
    const li = paare[i][0].closest('li');
    liste.style.setProperty('--mt-toc-y', li.offsetTop + 'px');
    liste.style.setProperty('--mt-toc-h', li.offsetHeight + 'px');
    // lange Verzeichnisse scrollen in sich: den markierten Eintrag sichtbar halten, ohne die Seite zu bewegen
    const e = li.getBoundingClientRect(), t = toc.getBoundingClientRect();
    if (toc.scrollHeight > toc.clientHeight && (e.top < t.top || e.bottom > t.bottom)) toc.scrollTop += e.top - t.top - t.height / 3;
  };
  addEventListener('scroll', setze, { passive: true });
  addEventListener('resize', () => { jetzt = -1; setze(); });
  setze();
})();
